import { useParams } from 'react-router-dom';
import { EscalateDialogModule } from '../../../modules/dialogs/escalate';

export const EscalateInvoicePage = () => {
  const { invoiceId } = useParams();

  if (!invoiceId) {
    throw new Error('Invoice ID not provided.');
  }

  return <EscalateDialogModule invoiceId={invoiceId} />;
};
